/**
 * Minimal shape of the Ant Design notification API we rely on — works with both
 * the static `notification` object and the instance from `notification.useNotification()`.
 */
export type WarningNotifier = {
  warning: (config: {
    message: string;
    description: string;
    duration: number;
  }) => void;
};

/**
 * Surface project-mutation warnings (e.g. a SharePoint folder that failed to be
 * created/renamed) as notifications. These stay open until dismissed
 * (`duration: 0`) because a folder that silently failed to create is exactly the
 * kind of thing a fleeting toast lets slip past the user.
 */
export const notifyProjectWarnings = (
  api: WarningNotifier,
  warnings?: string[]
): void => {
  if (!warnings?.length) return;

  warnings.forEach((description) => {
    api.warning({
      message: "SharePoint folder issue",
      description,
      duration: 0,
    });
  });
};
